import { render, staticRenderFns } from "./prenatal.vue?vue&type=template&id=347936b0&scoped=true"
import script from "./prenatal.vue?vue&type=script&lang=js"
export * from "./prenatal.vue?vue&type=script&lang=js"
import style0 from "./prenatal.vue?vue&type=style&index=0&id=347936b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347936b0",
  null
  
)

export default component.exports